import store from '@/store';

//预留，防止后面添加权限控制
export const revokePermission = function (needle) {
    return true
};



// WEBPACK FOOTER //
// ./src/libs/permission.js